// app/javascript/controllers/admin_events_filter_controller.js
import { Controller } from "@hotwired/stimulus"
import debounce from "debounce"

export default class extends Controller {
  static targets = ["title", "location", "eventType", "form"]
  static values = {
    url: String,
    debounceDelay: { type: Number, default: 300 }
  }

  connect() {
    this.initializeSelect2()
    this.debouncedSearch = debounce(this.performSearch.bind(this), this.debounceDelayValue)
  }

  disconnect() {
    // Clean up Select2 if it exists
    if (this.hasTitleTarget && typeof $.fn.select2 !== 'undefined') {
      $(this.titleTarget).select2('destroy')
    }
  }

  initializeSelect2() {
    if (this.hasTitleTarget && typeof $.fn.select2 !== 'undefined') {
      $(this.titleTarget).select2()

      // Bind Select2 events
      $(this.titleTarget).on('select2:select select2:clear', () => {
        this.debouncedSearch()
      })
    }
  }

  // Action for location dropdown change
  locationChanged() {
    this.debouncedSearch()
  }

  // Action for event type checkbox change
  eventTypeChanged() {
    this.debouncedSearch()
  }

  // Action for title change (Select2 handles this via events)
  titleChanged() {
    this.debouncedSearch()
  }

  performSearch() {
    const requestData = this.buildRequestData()

    $.ajax({
      url: this.urlValue,
      method: "GET",
      dataType: "script",
      data: requestData,
      beforeSend: () => {
        this.showLoading()
      },
      complete: () => {
        this.hideLoading()
      },
      error: (xhr, status, error) => {
        console.error('Search request failed:', error)
        this.showError()
      }
    })
  }

  buildRequestData() {
    let data = { page: 1 }

    // Get title value (Select2 or regular input)
    if (this.hasTitleTarget) {
      const titleValue = this.titleTarget.value
      if (titleValue && titleValue !== "") {
        data.title = titleValue
      }
    }

    // Get location value
    if (this.hasLocationTarget) {
      const locationValue = this.locationTarget.value
      if (locationValue && locationValue !== "") {
        data.location_id = locationValue
      }
    }

    // Get selected event types
    if (this.hasEventTypeTarget) {
      const selectedTypes = []
      this.eventTypeTargets.forEach(checkbox => {
        if (checkbox.checked) {
          selectedTypes.push(checkbox.value)
        }
      })

      if (selectedTypes.length > 0) {
        data.event_types = selectedTypes
      }
    }

    return data
  }

  showLoading() {
    // Add loading state to the form or results container
    if (this.hasFormTarget) {
      this.formTarget.classList.add('loading')
    }

    // You can also show a spinner or disable form elements
    const resultsContainer = document.querySelector('#admin_eventsss_partial')
    if (resultsContainer) {
      resultsContainer.style.opacity = '0.6'
      resultsContainer.style.pointerEvents = 'none'
    }
  }

  hideLoading() {
    // Remove loading state
    if (this.hasFormTarget) {
      this.formTarget.classList.remove('loading')
    }

    const resultsContainer = document.querySelector('#admin_eventsss_partial')
    if (resultsContainer) {
      resultsContainer.style.opacity = '1'
      resultsContainer.style.pointerEvents = 'auto'
    }
  }

  showError() {
    // Simple error handling - you can make this more sophisticated
    console.error('Failed to load search results')

    // Optional: Show user-friendly error message
    // const errorDiv = document.createElement('div')
    // errorDiv.className = 'alert alert-danger'
    // errorDiv.textContent = 'Помилка завантаження результатів пошуку'
    // this.formTarget.appendChild(errorDiv)
  }

  // Method to reset all filters
  resetFilters() {
    if (this.hasTitleTarget) {
      $(this.titleTarget).val(null).trigger('change')
    }

    if (this.hasLocationTarget) {
      this.locationTarget.value = ""
    }

    if (this.hasEventTypeTarget) {
      // Reset all checkboxes including the "select all" checkbox
      this.eventTypeTargets.forEach(checkbox => {
        checkbox.checked = false
      })

      // Trigger the checkbox-select-all controller to update its state
      const selectAllCheckbox = document.querySelector('[data-checkbox-select-all-target="checkboxAll"]')
      if (selectAllCheckbox) {
        selectAllCheckbox.checked = false
        selectAllCheckbox.dispatchEvent(new Event('change'))
      }
    }

    this.performSearch()
  }

  // Method to get current filter state (useful for debugging)
  getCurrentFilters() {
    return this.buildRequestData()
  }
}
